import { useEffect, useRef } from 'react';

export function useOnMount(onMount: (() => void) | undefined) {
    const isMountedRef = useRef(false);

    useEffect(() => {
        if (!isMountedRef.current) {
            isMountedRef.current = true;
            onMount?.();
        }
    }, [onMount]);
}
